export const feedbackInitialState = {
  question: {
    data: {},
    loading: false,
    error: null,
  },
  postFeedbackRequest: {
    loading: false,
    error: null,
  },
  feedbackResponses: {
    data: null,
    loading: false,
    error: null,
  },
};
